import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@powdr/components';
import { ColorProfiles, Components } from '@powdr/constants';

import { StyledScrollIndicator } from './styles';

export const ScrollIndicator = ({
  className = '',
  size = 50,
  onClick,
  parentColorProfile = ColorProfiles.BASE,
  component = Components.CONTENT_BLOCK_HERO,
  bottomOffset = 25,
  loopAnimation = false,
  fadeOut = false,
  ariaLabel,
}) => (
  <StyledScrollIndicator
    className={`bounce ${(loopAnimation) ? 'infinite' : ''} ${(fadeOut) ? 'hidden' : 'visible'} ${className}`}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    aria-label={ariaLabel}
    $colorProfile={parentColorProfile}
    $component={component}
    $bottomOffset={bottomOffset}
  >
    <Icon name="ui-arrow-scroll" width={size} height={size} />
  </StyledScrollIndicator>
);

ScrollIndicator.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
  bottomOffset: PropTypes.number,
  ariaLabel: PropTypes.string.isRequired,
  parentColorProfile: PropTypes.string,
  component: PropTypes.string,
  loopAnimation: PropTypes.bool,
  fadeOut: PropTypes.bool,
};
